











































































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ErrorList from '@/views/error-monitor/error-monitor-error-list.component.vue';
import SearchBar from '@/shared/search/search.component.vue';
import DropdownSystem from '@/shared/dropdown/dropdown.component.vue';
import ButtonRequest from '@/shared/button/button.component.vue';
import EventErrorService from '@/domain/event/event-error.service';
import EventAggregatorService from '@/domain/event/event-aggregator.service';
import EventAggregator from '@/domain/event/event-aggregator.entity';
import WorkItemFilterService from '@/domain/work-item/work-item-filter.service';
import WorkItemFilter from '@/domain/work-item/work-item-filter.entity';
import OriginSystem from '@/domain/origin/origin-system.entity';
import ProjectUserStore from '@/domain/project/project-with-members.store';
import Header from '@/views/error-monitor/header.json';

Component.registerHooks(['beforeRouteUpdate']);
@Component({
  components: {
    ErrorList,
    SearchBar,
    DropdownSystem,
    ButtonRequest,
  },
})
export default class ErrorMonitor extends Vue {
  private projectsStore = getModule(ProjectUserStore);

  private eventAggregatorService = new EventAggregatorService();

  private eventErrorService = new EventErrorService();

  private errors: EventAggregator[] = [];

  private originSystems: OriginSystem[] = [];

  filtro = '';

  private originSystemSelected: OriginSystem = new OriginSystem();

  private readonly headers: any[] = Header;

  private loading: boolean = false;

  private name: string = 'name';

  private selectedEventErrorIds: string[] = [];

  created() {
    this.projectsStore
      .fetchProjects()
      .then(() => this.requestErrorList(this.$route.params.projectName));
    WorkItemFilterService
      .getAllOriginSystems()
      .then(originSystems => this.originSystems = originSystems
        .map(name => OriginSystem.fromName(name)));
  }

  beforeRouteUpdate(to: any, from: any, next: any) {
    this.requestErrorList(to.params.projectName);
    next();
  }

  get filter() {
    const filteredError = this.filteredErrors(this.errors);
    return this.sortByOriginSystem(filteredError);
  }

  filteredErrors(errorList: EventAggregator[]) {
    if (this.filtro && this.filtro.length) {
      return errorList.filter(value => value.description
        .toLowerCase()
        .includes(this.filtro.toLowerCase().trim()));
    }
    return this.errors;
  }

  sortByOriginSystem(errorList: EventAggregator[]) {
    if (this.originSystemSelected) {
      return errorList.filter(value => value.originSystem.match(this.originSystemSelected.name));
    }
    return errorList;
  }

  requestErrorList(projectName: string) {
    this.loading = true;
    this.projectsStore
      .getProject(projectName)
      .then(project => this.eventAggregatorService
        .searchAllAggregators(project.id)
        .then(errors => (this.errors = errors)))
      .finally(() => {
        this.loading = false;
        this.selectedEventErrorIds = [];
      });
  }

  clearErrors(projectName: string) {
    this.loading = true;
    this.projectsStore
      .getProject(projectName)
      .then(project => this.eventAggregatorService
        .clearEventErrors(project.id)
        .then((resp: any) => this.requestErrorList(projectName)))
      .finally(() => (this.loading = false));
  }

  reprocessSelectedErrors() {
    this.loading = true;
    this.eventErrorService.reprocessSelectedErrors(this.selectedEventErrorIds)
      .finally(() => {
        this.loading = false;
        this.selectedEventErrorIds = [];
        this.requestErrorList(this.$route.params.projectName);
      });
  }
}
